import { render, staticRenderFns } from "./OrdresPendentsG.vue?vue&type=template&id=a99ccbb0&"
import script from "./OrdresPendentsG.vue?vue&type=script&lang=js&"
export * from "./OrdresPendentsG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports